module.exports = __webpack_public_path__ + "img/tentarNovamente.798b5fd1.png";